<template>
    <div class="award-trophy-wrapper">
        <Row :gutter="32">
            <i-col :xs="12" v-if="awardTrophies.length">
                <p>{{game.gameRef.gameTitle}}</p>
                <Table ref="awardTrophiesTable" class="table-hide-header" style="margin-top: 8px;" :columns="columns" width="400" :loading="dataLoading" :data="awardTrophies">
                    <p slot-scope="{ row, index }" slot="AwardTrophyName">
                        '{{row.Trophy.TrophyName}}' in '{{row.Tournament.TournamentName}}'
                    </p>
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteAwardTrophy(row,index)">Delete</Button>
                    </div>
                </Table>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { getGameTrophies,deleteGameTrophy } from "../../_services/game.service";

    export default {
        components:{
        },
        data() {
            return {
                dataLoading:false,
                submitLoading:false,
                activeTournament:null,
                game:{},
                columns: [
                    {
                        title: " ",
                        slot: "AwardTrophyName"
                    },
                    {
                        title:" ",
                        slot:"action",
                        align:"right",
                        width: "80"
                    }
                ],
                awardTrophies:[]
            };
        },
        methods: {
            deleteAwardTrophy(data,index) {
                this.$Modal.confirm({
                    title: 'Remove Trophy',
                    content: "Are you sure you want to remove tournament trophy?",
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteGameTrophy(data._id).then(res => {
                            this.awardTrophies.splice(index, 1);
                            this.dataLoading = false
                            this.$Message.success(`Successfully deleted tournament trophy!`);
                        }).catch(err => {
                            this.dataLoading = false
                            this.$Message.error("Failed to remove tournament trophy. Please try again later.");
                        });
                    },
                });
            },
            getGameTrophiesList(id,gameData) {
                this.dataLoading=true
                this.game=gameData
                getGameTrophies(id).then(res => {
                    this.dataLoading=false
                    this.awardTrophies=res.data.data
                    if(res.data.data.length) {
                        this.$emit('updateAwardList', res.data.data)
                    }else {
                        this.$emit('updateAwardList', [])
                    }
                }).catch(err => {
                    this.dataLoading=false
                    this.$emit('updateAwardList', [])
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to get award Trophies. Please try again later");
                });
            },
        },
        mounted() {
        }
    };
</script>
<style scoped>
    .award-trophy-wrapper{
        margin-top: 32px;
    }
</style>
